import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    'step',
    'form',
    'skillTagField'
  ];

  nextForm(e) {
    e.preventDefault();
    // メールアドレス認証にリモートチェックが必要なので非同期バリデート
    this.formController.asyncValidate(e, `block-${this.stepController.index}`, () => {
      this.stepController.next(e);
    })
  }

  prevForm(e) {
    e.preventDefault();
    this.stepController.prev(e);
  }

  updateProfession(e) {
    this.skillTagFieldController.setProfessionId(e.currentTarget.value);
  }

  get stepController() {
    return this.application.getControllerForElementAndIdentifier(
      this.stepTarget,
      "step"
    );
  }

  get formController() {
    return this.application.getControllerForElementAndIdentifier(
      this.formTarget,
      "form"
    );
  }

  get skillTagFieldController() {
    return this.application.getControllerForElementAndIdentifier(
      this.skillTagFieldTarget,
      "skill-tag-field"
    );
  }
}
